export enum KeyTypeEnum {
	CODE_VERIFIER = 'codeVerifier',
	ID_TOKEN = "idToken"
}